/**
 * icon-title.js
 */

import React from 'react';
import { Box, Typography } from '@mui/material';
import Icon from 'components/icon';


export default function IconTitle(props) {
  const { iconType, title, subtitle, actions, gutterBottom, fullWidth } = props;


  return (
    <>
      <Box sx={{ mb: gutterBottom ? 3 : 0 }}>
        <Box className='flex-hc' sx={{ mb: .5 }}>
          <Icon type={iconType} sx={{ mr: 1.5 }} />
          <Typography variant='h6' sx={{ flex: 1 }}>{title}</Typography>
          {actions}
        </Box>
        <Typography variant='subtext-large' sx={{ maxWidth: fullWidth ? 'unset' : undefined }}>{subtitle}</Typography>
      </Box>
    </>
  )
}